import { combineReducers } from 'redux';
import alert from './alertReducer';
import auth from './authReducer';
import nav from './navReducer';
import post from './postReducer';
import chat from './chatReducer';
import notification from './notificationReducer';
import search from './searchReducer';
import ad from './adReducer';
import group from './groupReducer';
import sport from './sportsMatchReducer';
import category from './categoryReducer';

export default combineReducers({
    alert,
    auth,
    nav,
    post,
    chat,
    notification,
    search,
    ad,
    group,
    sport,
    category
});